<template>
  <section>
    <div class="title">
      <span>价格配置</span>
    </div>
    <el-tabs v-model="activeName" class="price-tabs-warp">
      <el-tab-pane label="通用配置" name="commConf">
          <CommPriceConf ref="commPriceConfRef" :priceConfName="getPriceName(platform)" :priceList="priceList" :platform="platform" />
      </el-tab-pane>
      <el-tab-pane label="店铺价格配置" name="shopPriceConf">
          <ShopPriceConf ref="shopPriceConfRef" :platform="platform" :priceConfName="getPriceName(platform)" :shopPriceConf="shopPriceConf" />
      </el-tab-pane>
    </el-tabs>
  </section>
</template>
<script>
import '@/assets/css/prod.scss';
import CommPriceConf from './CommPriceConf.vue'
import ShopPriceConf from './ShopPriceConf/index.vue'
import { getPriceName } from '@/dictionary/price';

export default {
  props: {
    platform: String,
    priceList: {
      type: Array,
      default: () => [],
    },
    shopPriceConf:{
      type:Array,
      default: () => []
    },
  },
  components: {
      CommPriceConf,
      ShopPriceConf,
  },
  computed:{
  },
  data() {
    return {
      activeName:'commConf',
      getPriceName
    };
  },
  methods: {
    getData() {
      let commConf = this.$refs.commPriceConfRef.getData();
      let shopConf = this.$refs.shopPriceConfRef.getData();
      return [commConf,shopConf]
    },
  },
};
</script>

<style lang="scss">
.price-tabs-warp{
  margin-top: 10px;
}
.price-tabs-warp .el-tabs__content{
  height: auto !important;
}
</style>